import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Decorative, Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSamplesGuestRetailerConfirmationModalUpsellClick } from "@faire/web-api--source/events/samples/click/guestRetailerConfirmationModalUpsell";
import SignUpPersonalRoute, { QueryParameters as SignUpQueryParameters } from "@faire/web-api--source/routes/welcome/r/personal";
import * as React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import { BannerPicture } from "@faire/retailer/views/brand/BrandHeader/BannerPicture";
// We have a special FD extension only for sampling retailers
var SAMPLE_FD_EXPIRY_EXTENSION_DAYS = 30;
export var GuestRetailerConfirmationModal = /*#__PURE__*/ React.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _jsxs(StyledColumn, {
        ref: ref,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displaySSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ph0zJj",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We got your request"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(StyledTypography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "PdK2TO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We'll start working on your sample right away. Bon app\u00E9tit!"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(UpsellCard, _object_spread({}, props))
        ]
    });
});
var UpsellCard = function(param) {
    var bannerImage = param.bannerImage, name = param.name, email = param.email, phoneNumber = param.phoneNumber, storeName = param.storeName, country = param.country, googlePlaceId = param.googlePlaceId, onLearnMoreClick = param.onLearnMoreClick;
    var faireDirectBrandAlias = useFaireDirectBrand().faireDirectBrandAlias;
    var fdb = useQueryParams(SignUpQueryParameters.parse).fdb;
    var replace = useHistory().replace;
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedPercentageBasedNumber = _useFaireDirectFirstOrderIncentive.formattedPercentageBasedNumber, formattedMaxPercentageDiscountAmount = _useFaireDirectFirstOrderIncentive.formattedMaxPercentageDiscountAmount, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount;
    var goToSignUp = function() {
        trackSamplesGuestRetailerConfirmationModalUpsellClick();
        replace(SignUpPersonalRoute(SignUpQueryParameters.build({
            name: name,
            email: email,
            storeName: storeName,
            googlePlaceId: googlePlaceId,
            fdb: fdb !== null && fdb !== void 0 ? fdb : faireDirectBrandAlias,
            countryIso3: country,
            phone_number: phoneNumber
        })));
    };
    return /*#__PURE__*/ _jsxs(CardColumn, {
        children: [
            /*#__PURE__*/ _jsx(BannerContainer, {
                children: /*#__PURE__*/ _jsx(BannerPicture, {
                    brandImage: bannerImage
                })
            }),
            /*#__PURE__*/ _jsxs(PaddedContent, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansRegular",
                        color: Decorative.icon.orange,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "AUkWx8",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Special offer"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "pageHeaderSerifRegular",
                        children: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "h7X+3G",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Place a full order and get "
                                },
                                {
                                    type: 1,
                                    value: "faireDirectPercentageDiscountNumber"
                                },
                                {
                                    type: 0,
                                    value: " off & 1 year of free shipping*"
                                }
                            ],
                            values: {
                                faireDirectPercentageDiscountNumber: formattedPercentageBasedNumber
                            }
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "dWaqWC",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Place a full order and get "
                                },
                                {
                                    type: 1,
                                    value: "promoMoney"
                                },
                                {
                                    type: 0,
                                    value: " off & 1 year of free shipping*"
                                }
                            ],
                            values: {
                                promoMoney: formattedFixedBasedAmount
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(CardBodyTypography, {
                        children: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "VfXQNm",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Join Faire today and get "
                                },
                                {
                                    type: 1,
                                    value: "faireDirectPercentageDiscountNumber"
                                },
                                {
                                    type: 0,
                                    value: " off your first order and 1 year of free shipping with us."
                                }
                            ],
                            values: {
                                faireDirectPercentageDiscountNumber: formattedPercentageBasedNumber
                            }
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "NfmrjL",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Join Faire today and get "
                                },
                                {
                                    type: 1,
                                    value: "promoMoney"
                                },
                                {
                                    type: 0,
                                    value: " off your first order and 1 year of free shipping with us."
                                }
                            ],
                            values: {
                                promoMoney: formattedFixedBasedAmount
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(CtaContainer, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            onClick: goToSignUp,
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "ilGIv0",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Create account & claim offer"
                                    }
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        align: "flex-start",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "tertiary",
                                onClick: onLearnMoreClick,
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraphSansRegular",
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "UyTF8E",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Learn more about Faire"
                                            }
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "4x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansRegular",
                                color: Core.text.subdued,
                                children: isFaireDirectCreditPercentageBased ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "IFYgYW",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "*Max discount of "
                                        },
                                        {
                                            type: 1,
                                            value: "faireDirectMaxDiscountNumber"
                                        },
                                        {
                                            type: 0,
                                            value: ". Expires "
                                        },
                                        {
                                            type: 1,
                                            value: "expiresInDaysNumber"
                                        },
                                        {
                                            type: 0,
                                            value: " days after signup."
                                        }
                                    ],
                                    values: {
                                        faireDirectMaxDiscountNumber: formattedMaxPercentageDiscountAmount,
                                        expiresInDaysNumber: SAMPLE_FD_EXPIRY_EXTENSION_DAYS
                                    }
                                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "tGesjT",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "*Expires "
                                        },
                                        {
                                            type: 1,
                                            value: "expiresInDaysNumber"
                                        },
                                        {
                                            type: 0,
                                            value: " days after signup."
                                        }
                                    ],
                                    values: {
                                        expiresInDaysNumber: SAMPLE_FD_EXPIRY_EXTENSION_DAYS
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var StyledColumn = styled(Column).attrs({
    gap: "1x",
    align: "center"
}).withConfig({
    componentId: "sc-12a4bd5d-0"
})([
    "width:500px;padding:",
    ";text-align:center;",
    "{width:350px;}"
], getSpacing("2x", 0, 0), responsiveMediaQueries.mobile);
var CardColumn = styled(Column).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-12a4bd5d-1"
})([
    "background:",
    ";border-radius:10px;overflow:hidden;margin-top:",
    ";box-shadow:0 2px 10px rgba(0,0,0,0.15);text-align:left;"
], Core.surface.inverse, getSpacing("6x"));
var StyledTypography = styled(Typography).attrs({
    variant: "paragraphSansRegular"
}).withConfig({
    componentId: "sc-12a4bd5d-2"
})([
    "text-align:center;"
]);
var CardBodyTypography = styled(Typography).attrs({
    variant: "paragraphSansRegular"
}).withConfig({
    componentId: "sc-12a4bd5d-3"
})([
    "&&&{padding:",
    ";}"
], getSpacing("1x", 0));
var PaddedContent = styled(Column).attrs({
    gap: "1x"
}).withConfig({
    componentId: "sc-12a4bd5d-4"
})([
    "padding:",
    ";"
], getSpacing("2x", "3x", "3x"));
var BannerContainer = styled(Column).withConfig({
    componentId: "sc-12a4bd5d-5"
})([
    "height:110px;"
]);
var CtaContainer = styled(Column).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-12a4bd5d-6"
})([
    "margin:",
    ";"
], getSpacing("1x", 0));
